module.exports = __webpack_public_path__ + "img/birthday_v1.7c3e908.png";